import { render, staticRenderFns } from "./CadastroSuspensaoAdvogados.vue?vue&type=template&id=1778d4f5"
import script from "./CadastroSuspensaoAdvogados.vue?vue&type=script&lang=js"
export * from "./CadastroSuspensaoAdvogados.vue?vue&type=script&lang=js"
import style0 from "./CadastroSuspensaoAdvogados.vue?vue&type=style&index=0&id=1778d4f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports